import { ChevronLeft } from 'lucide-react';
import { SkloKruh } from './Sklo';

/**
 * Návrat z detailu na mobilu — jen šipka, bez rámečku a bez textu „Zpět".
 *
 * Stejný tvar jako app bar dokladu (`HlavickaMobil` ve `FinanceDokladyDetail`):
 * 44 × 44 px na prst, ikona 22 px. Záporný levý okraj srovná šipku s hranou
 * obsahu, dotyková plocha přitom zůstane plná. Popis nese `aria-label`.
 *
 * `sklo` — varianta horního ovládání na mobilu (skleněný kruh, `Sklo.jsx`).
 * Zatím v Komunikaci; až se osvědčí, stane se výchozí.
 */
export default function ZpetTlacitko({ onClick, popis = 'Zpět', barva = 'var(--text-primary)', style, sklo = false, isDark }) {
    if (sklo) {
        return <SkloKruh Icon={ChevronLeft} ikona={22} popis={popis} onClick={onClick} isDark={isDark} style={style} />;
    }
    return (
        <button type="button" onClick={onClick} aria-label={popis} title={popis}
            className="inline-flex items-center justify-center flex-shrink-0"
            style={{
                width: 44, height: 44, marginLeft: -10, padding: 0,
                border: 'none', background: 'transparent', color: barva,
                cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
                ...style,
            }}>
            <ChevronLeft size={22} />
        </button>
    );
}
